import { createGetEndpoint, HttpHeader } from '@sonar-software/sonar-http';

export type GetPasswordResetLinkRequest = {
	userId: number;
	shardName?: string;
};

export type GetPasswordResetLinkResponse = {
	link: string;
};

export const getPasswordResetLink = createGetEndpoint<GetPasswordResetLinkRequest, GetPasswordResetLinkResponse>(
	(request) => `/api/v3/core/users/${request?.userId}/links/password-reset`,
	{
		headers: (request) => {
			if (request?.shardName) {
				return { [ HttpHeader.Shard ]: request.shardName };
			}

			return {};
		},
		skipAuthRefresh: true
	}
);
